export default __webpack_public_path__ + "static/media/level-one-approved.58ca2fd2.svg";